/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import { sortableContainer, sortableElement } from 'react-sortable-hoc';
import arrayMove from 'array-move';
import { PulseLoader } from 'react-spinners';
import { FaBars } from 'react-icons/fa';
import { compose, graphql } from 'react-apollo';
import { withAlert } from 'react-alert';
import { reorderCategory, categories as categoriesPortal } from '../../../../../queries';

import {
  Padding,
  Content,
  Container,
  ListItem,
  Button,
} from './styles';


const SortableItem = sortableElement(({ value }) => (
  <ListItem>
    <FaBars className="fa fa-bars" />
    {value}
  </ListItem>
));

const SortableContainer = sortableContainer(({ children }) => (
  <ul className="sortable-helper">
    {children}
  </ul>
));

class ReorderCategoryModal extends Component {
  state = {
    loading: false,
    categories: [],
  }

  openReorderCategoryModal = (categories) => {
    this.setState({ categories });
  }

  handleSubmit = async () => {
    const { categories } = this.state;

    this.setState({ loading: true });

    const arr = [];

    categories.forEach((category, index) => {
      arr.push({
        ...category,
        position: index,
      });
    });

    this.props
      .reorderCategory({
        variables: {
          storeId: this.props.storeId,
          categories: arr,
        },
        refetchQueries: [{ query: categoriesPortal, variables: { storeId: this.props.storeId } }],
      })
      .then(async (res) => {
        this.setState({ loading: false });
        this.props.handleCategoriesList(res.data.reorderCategoryPortal);
        this.props.alert.success('Categorias reordenadas com sucesso');
        this.props.close();
      });
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(({ categories }) => ({
      categories: arrayMove(categories, oldIndex, newIndex),
    }));
  };

  render() {
    const {
      loading,
      categories,
    } = this.state;

    const { open, close } = this.props;

    return (
      <Modal
        open={open}
        onClose={close}
        center
        ref={(ref) => { this.categoryModal = ref; }}
        styles={{
          modal: { width: '460px' },
        }}
      >
        <Content>
          <Padding>
            <h2>Reordenar categorias</h2>
          </Padding>
          <Container>
            <SortableContainer onSortEnd={this.onSortEnd}>
              {categories.map((category, index) => (
                <SortableItem key={`item-${index}`} index={index} value={category.label} />
              ))}
            </SortableContainer>
          </Container>
          <Padding>
            <Button type="submit" disabled={loading} onClick={this.handleSubmit}>
              {!loading ? (
                'Salvar'
              ) : (
                <PulseLoader
                  sizeUnit="px"
                  size={7}
                  color="#FFFFFF"
                  loading={loading}
                />
              )}
            </Button>
          </Padding>
        </Content>
      </Modal>
    );
  }
}

export default compose(
  withAlert(),
  graphql(reorderCategory, { name: 'reorderCategory', withRef: true }),
)(ReorderCategoryModal);
